module.exports = __webpack_public_path__ + "static/74gde-8b43c8c0d1bf748ac614fa07ab16f62b.gif";